var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconUserAction = function SvgIconUserAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1810_4215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.671 11.1385V6.70755C12.671 5.89154 12.01 5.23055 11.194 5.23055C10.378 5.23055 9.71703 5.89154 9.71703 6.70755V10.1535V15.2305L7.07103 13.8725C6.46903 13.5635 5.73603 13.6785 5.25803 14.1565C4.62503 14.7895 4.65503 15.8245 5.32303 16.4205L10.148 20.7235C10.514 21.0505 10.988 21.2305 11.479 21.2305H16.112C17.049 21.2305 17.861 20.5795 18.064 19.6645L19.137 14.8345C19.45 13.4245 18.507 12.0425 17.08 11.8215L12.671 11.1385V11.1385Z",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.73108 4.23055C9.16508 1.09655 13.1121 1.09655 15.5461 4.23055",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1810_4215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
export { SvgIconUserAction as ReactComponent };
export default __webpack_public_path__ + "icon-user-action.svg";